<div *ngIf="triggers && triggers.length > 0">
  <div class="grid" style="margin-top: 8px;">
    <div class="col-12">
      <div class="flex flex-column sm:flex-row justify-content-between card">
        <div class="flex flex-column sm:flex-row">
          <p-calendar
            [(ngModel)]="rangeDates"
            [firstDayOfWeek]="1"
            [readonlyInput]="false"
            styleClass="w-full"
            selectionMode="range"
            dateFormat="dd/mm/yy"
            inputId="range"
          ></p-calendar>
          <p-dropdown
            [(ngModel)]="selectedTrigger"
            [options]="triggers"
            [filter]="true"
            class="mt-2 sm:mt-0 sm:ml-2"
            styleClass="dropdown-custom-padding w-full"
            optionLabel="name"
            filterBy="name"
          >
            <ng-template pTemplate="selectedItem">
              <div class="flex align-items-center" *ngIf="selectedTrigger">
                <div>
                  <p-tag
                    styleClass="text-sm py-0 my-0"
                    value="{{selectedTrigger.type}}({{selectedTrigger.expression}})"
                    severity="info"
                  ></p-tag>
                </div>
                <div class="ml-1">
                  {{selectedTrigger.name}}
                </div>
              </div>
            </ng-template>
            <ng-template let-trigger pTemplate="item">
              <div class="flex align-items-center">
                <div>
                  <p-tag
                    styleClass="text-sm py-0 my-0"
                    value="{{trigger.type}}({{trigger.expression}})"
                    severity="info"
                  ></p-tag>
                </div>
                <div class="ml-1">
                  {{trigger.name}}
                </div>
              </div>
            </ng-template>
          </p-dropdown>
          <p-button
            [label]="'common.search' | transloco"
            (onClick)="searchEvents()"
            class="mt-2 sm:mt-0 sm:ml-2"
            styleClass="w-full"
          ></p-button>
        </div>
      </div>
    </div>
  </div>
  <div class="flex" style="margin-top: 8px;">
    <div class="card w-full">
      <div class="p-datatable p-component p-datatable-hoverable-rows">
        <p-table
          [(first)]="first"
          [(rows)]="rows"
          [value]="events"
          [totalRecords]="totalEvents"
          [responsive]="true"
          [paginator]="true"
          [rowsPerPageOptions]="[10,25,50]"
          sortField="triggeredDate"
          [sortOrder]="-1"
          styleClass="p-datatable-striped"
        >
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="triggeredDate">
                {{'attribute.triggeredDate' | transloco}}<p-sortIcon field="triggeredDate"></p-sortIcon></th>
              <th pSortableColumn="evaluationDate">
                {{'attribute.evaluationDate' | transloco}}<p-sortIcon field="evaluationDate"></p-sortIcon></th>
              <th pSortableColumn="value">
                {{'attribute.value' | transloco}}<p-sortIcon field="value"></p-sortIcon></th>
              <th pSortableColumn="evaluation">
                {{'attribute.evaluation' | transloco}}<p-sortIcon field="evaluation"></p-sortIcon></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-event>
            <tr *ngIf="!loadingEvents" class="fadein">
              <td>
                <span class="p-column-title bold">{{'attribute.triggeredDate' | transloco}}</span>
                {{event.triggeredDate | customDate}}
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.evaluationDate' | transloco}}</span>
                {{event.evaluationDate | customDate}}
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.value' | transloco}}</span>
                {{event.value}}
              </td>
              <td class="m-0">
                <span class="p-column-title bold">{{'attribute.evaluation' | transloco}}</span>
                <p [className]="event.evaluation ? 'success-color' : 'danger-color'">
                  <i [className]="event.evaluation ? 'pi pi-check' : 'pi pi-times'"></i>
                  {{(event.evaluation ? 'common.true' : 'common.false') | transloco}}
                </p>
              </td>
            </tr>
            <tr *ngIf="loadingEvents" class="fadein animation-delay-200 animation-fill-forwards no-opacity">
              <td class="row-height selection-column-width"><p-skeleton height="1em"></p-skeleton></td>
              <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
              <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
              <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
            </tr>
          </ng-template>
          <ng-template pTemplate="summary">
            <div class="flex align-items-center justify-content-between" *ngIf="totalEvents == 0">
              {{'pagination.empty' | transloco}}
            </div>
            <div class="flex align-items-center justify-content-between" *ngIf="totalEvents > 0">
              {{'pagination.showing' | transloco}} {{first+1}}
              {{'pagination.to' | transloco}} {{(first+rows) >= totalEvents ? totalEvents : (first+rows)}}
              {{'pagination.of' | transloco}} {{totalEvents}}
              {{(totalEvents > 1 ? 'pagination.entries':'pagination.entry') | transloco}}
            </div>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>
<div class="flex" style="margin-top: 15px;" *ngIf="triggers && triggers.length == 0">
  <div class="card w-full">
    <p class="text-xl text-center p-6 font-italic">{{'empty.events' | transloco}}</p>
  </div>
</div>
<div class="flex" style="margin-top: 15px;" *ngIf="!triggers">
  <div class="card w-full">
    <app-table-skeleton [rows]="14"></app-table-skeleton>
  </div>
</div>
